import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';

const QUERY_GET_CHARGES = ['QUERY_GET_CHARGES'];

export type FiltersCharge = {
    date: string | undefined;
    'stores[]': Array<number> | undefined;
    shopmanagerId?: string;
    email: string | undefined;
    page: number;
    perPage: number;
};

export interface Charge {
    automatic_monthly_fee: number;
    monthly_invoice: number;
    store_id: number;
    reference_date: string;
    store: Store;
}

export interface InhouseTax {
    id: number;
    value: number;
    expense: number;
    reference_date: string;
    store_id: number;
}

export interface Store {
    name: string;
    id: number;
    shopmanager_id: number;
    shopManager: ShopManager;
}

export interface ShopManager {
    id: number;
    user_id: number;
    user: User;
}

export interface User {
    email: string;
    id: number;
}

export interface Meta {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    first_page: number;
    first_page_url: string;
    last_page_url: string;
    next_page_url: any;
    previous_page_url: any;
}

export interface ChargeResponse {
    meta: Meta;
    data: Array<Charge>;
}

export async function fetchCharges(filters: FiltersCharge) {
    const response = await api.get<ChargeResponse>(
        `financial-reports/report/charges`,
        {
            params: filters,
        },
    );
    return response.data;
}

export function useGetCharge(filters: FiltersCharge, enableRequest: boolean) {
    return useQuery({
        queryKey: [QUERY_GET_CHARGES, filters],
        queryFn: () => fetchCharges(filters),
        retry: false,
        refetchOnWindowFocus: false,
        enabled: enableRequest,
    });
}
